import { Button, Col, Dropdown, Form, Icon, Menu, message, Modal, Row, Switch, Tag } from "antd";
import OrganizationApi from "api/OrganizationApi";
import DynamicTable from "components/elements/dynamic-table";
import slug from "constants/slug";
import { autobind } from "core-decorators";
import createManagerDelete from "hoc/manager-delete";
import createManagerList from "hoc/manager-list";
import PageContainer from "layout/default-sidebar-layout/PageContainer";
import * as _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import TimeAgo from "react-timeago";
import styled from "styled-components";
import createLanguageHoc, { langPropTypes } from "../../../hoc/create-lang";
import Breadcrumb from "../breadcrumb";

import { get } from "lodash";
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
import { toggleWarningUpdateVersion } from "../../../api/OrganizationApi";

const frenchStrings = {
  prefixAgo: "cách đây",
  prefixFromNow: null,
  suffixAgo: null,
  suffixFromNow: "nữa",
  seconds: "chưa đến 1 phút",
  minute: "khoảng 1 phút",
  minutes: "%d phút",
  hour: "khoảng 1 tiếng",
  hours: "khoảng %d tiếng",
  day: "1 ngày",
  days: "%d ngày",
  month: "khoảng 1 tháng",
  months: "%d tháng",
  year: "khoảng 1 năm",
  years: "%d năm",
  wordSeparator: " "
};

const formatter = buildFormatter(frenchStrings);

const LinkSpan = styled.span`
  color: #000;
  &:hover {
    cursor: pointer;
  }
`;
const IconButton = styled(Icon)`
  padding-right: 5px;
  color: ${props => (props.color ? props.color : "#3E90F7")};
`;
const Span = styled.span`
  color: ${props => (props.deleted ? "#999999" : "")};
  text-decoration: ${props => (props.deleted ? "line-through" : "")};
`;

@Form.create()
@createManagerList({
  apiList: OrganizationApi.getOrganizations
})
@createManagerDelete({
  apiDelete: OrganizationApi.removeOne
})
@createLanguageHoc
@autobind
export default class LicenseList extends React.Component {
  state = {
    isWarningNewUpdated: false
  }
  static propTypes = {
    pagination: PropTypes.object,
    pathImg: PropTypes.string,
    onChangePage: PropTypes.func,
    onChangePageSize: PropTypes.func,
    onDeleteItem: PropTypes.func,
    fetchData: PropTypes.func,
    lang: langPropTypes
  };

  componentDidMount = () => {
   this.setWarningUpdateNewVersion()
  }

  componentDidUpdate = (prevProps) => {
   const {dataSource} = this.props

   if((prevProps.dataSource || []).length !== dataSource.length) {
    this.setWarningUpdateNewVersion()
   }
  }
  
  //#region toggle warning update version
  setWarningUpdateNewVersion = () => {
    const { dataSource, form } = this.props;

    const isWarningNewUpdated = get(dataSource, ["0", "license", "isWarningNewUpdated"], false)
    form.setFieldsValue({
      toggleWarning: isWarningNewUpdated
    })
  }

  handleToggleWarning = async (isChecked, t) => {
    try {
     await toggleWarningUpdateVersion(isChecked)
     message.info(t("addon.onSave.update.success"));
    } catch (error) {
      console.error({error});
    }
  }
  //#endregion toggle warning update version

  buttonAdd() {
    return (
      <div>
        <Link to={slug.organization.create}>
          <Button type="primary">
            <Icon type="plus" />
            Create
          </Button>
        </Link>
      </div>
    );
  }

  actionGroup(row) {
    const {
      lang: { t }
    } = this.props;
    // let accountEnable = true
    // if (row.accountStatus && row.accountStatus.enable === false) {
    //   accountEnable = false
    // }
    let dropdown;

    if (row.removeStatus && row.removeStatus.allowed)
      dropdown = this.getMenuIsDeleting(row, t);
    else dropdown = this.getMenuNotDeleting(row, t);

    return (
      <Dropdown overlay={dropdown} trigger={["click"]}>
        <LinkSpan className="ant-dropdown-link">
          <Icon type="setting" style={{ fontSize: 20, color: "#3E90F7" }} />
        </LinkSpan>
      </Dropdown>
    );
  }

  getMenuNotDeleting(row, t) {
    return (
      <Menu>
        <Menu.Item key="0">
          <Link to={slug.organization.editWithKey + "/" + row._id}>
            <IconButton type="edit" />
            {t("addon.edit")}
          </Link>
        </Menu.Item>
        <Menu.Item key="1">
          <a onClick={() => this.onDeleteItem(row._id, this.props.fetchData)}>
            <IconButton type="delete" color={"red"} />
            {t("addon.delete")}
          </a>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to={slug.organization.ruleWithKey + "/" + row._id}>
            <IconButton type="usergroup-add" />
            {t("organization.rule.label")}
          </Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to={slug.organization.packageInfoWithKey + "/" + row._id}>
            <IconButton type="profile" />
            {t("organization.package.label")}
          </Link>
        </Menu.Item>
      </Menu>
    );
  }

  getMenuIsDeleting(row, t) {
    return (
      <Menu>
        <Menu.Item key="1">
          <a onClick={() => this.onRestoreItem(row._id, this.props.fetchData)}>
            <IconButton type="reload" />
            {t("addon.restore")}
          </a>
        </Menu.Item>
        <Menu.Item key="2">
          <a
            onClick={() =>
              this.props.onDeleteItem(row._id, this.props.fetchData)
            }
          >
            <IconButton type="close-square-o" color={"red"} />
            {t("addon.remove")}
          </a>
        </Menu.Item>
      </Menu>
    );
  }

  async onDeleteItem(_id, callback) {
    const {
      lang: { t }
    } = this.props;
    Modal.confirm({
      title: "Do you want to delete these items?",
      onOk() {
        return new Promise(async (resolve, reject) => {
          const res = await OrganizationApi.deleteOne(_id);
          if (res.success) {
            message.info(t("addon.onDelete.success"));
            callback();
          } else message.error(t("addon.onDelete.error"));
          resolve();
        }).catch(() => console.log("Oops errors!"));
      },
      onCancel() {}
    });
  }

  async onRestoreItem(_id, callback) {
    const {
      lang: { t }
    } = this.props;
    Modal.confirm({
      title: "Do you want to restore these items?",
      onOk() {
        return new Promise(async (resolve, reject) => {
          const res = await OrganizationApi.restoreOne(_id);
          if (res.success) {
            message.info(t("addon.onRestore.success"));
            callback();
          } else message.error(t("addon.onRestore.error"));
          resolve();
        }).catch(() => console.log("Oops errors!"));
      },
      onCancel() {}
    });
  }

  getHead() {
    const {
      lang: { t }
    } = this.props;
    return [
      { content: "#", width: 2 },
      { content: t("organization.form.name.label"), width: 30 },
      { content: t("organization.form.databaseInfo.name.label"), width: 20 },
      { content: t("organization.form.totalUser.label"), width: 15 },
      { content: t("organization.form.totalStation.label"), width: 15 },
      { content: t("organization.form.expirationDate.label"), width: 15 }
    ];
  }

  getRows() {
    return this.props.dataSource.map((row, index) => {
      const totalStation = _.get(row, "license.totalStation", null);
      const totalUser = _.get(row, "license.totalUser", null);
      return [
        {
          content: (
            <strong>
              {(this.props.pagination.page - 1) *
                this.props.pagination.itemPerPage +
                index +
                1}
            </strong>
          )
        },
        {
          content: (
            <Span deleted={row.removeStatus && row.removeStatus.allowed}>
              &emsp;{row.name}
            </Span>
          )
        },
        {
          content: (
            <Span deleted={row.removeStatus && row.removeStatus.allowed}>
              &emsp;{row.databaseInfo ? row.databaseInfo.name : ""}
            </Span>
          )
        },
        {
          content: totalUser > 0 ? <Tag color="green">{totalUser}</Tag> : null
        },
        {
          content:
            totalStation > 0 ? <Tag color="green">{totalStation}</Tag> : null
        },
        {
          content: (
            <TimeAgo
              date={_.get(row, "license.expirationDate", null)}
              // date={"2020-11-11 08:08:08"}
              formatter={formatter}
            />
          )
        }
      ];
    });
  }

  render() {
    const {
      lang: { t }, form
    } = this.props;

    return (
      <PageContainer
      right={
        <Row type="flex" align="middle" gutter={8}>
          <Col>
            <div style={{ fontWeight: 500, color: '#111827' }}>{t("addon.updateVersion")}:</div> 
          </Col>
          <Col>
            {form.getFieldDecorator("toggleWarning", {
              valuePropName: 'checked',
              onChange: (value) => this.handleToggleWarning(value, t)
            })(
              <Switch />
            )}
          </Col>
        </Row>
      }
      >
        <Breadcrumb items={["list"]} />
        <DynamicTable
          loading={this.props.isLoading}
          rows={this.getRows()}
          head={this.getHead()}
          paginationOptions={{
            isSticky: true
          }}
          onSetPage={this.props.onChangePage}
          pagination={this.props.pagination}
        />
      </PageContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/license/license-list/index.js